const convertOrderCombosToCartCombos = (orderItems) => {
  const comboOrderItems =
    orderItems.filter(item => !!item.comboSet)

  const combos = []

  comboOrderItems.forEach(comboOrderItem => {
    const comboSet = comboOrderItem.comboSet

    const newItem = {
      comboSetItemId: comboSet.comboSetItemId,
      comboSetId: comboSet._id,
      foodCode: comboOrderItem.foodCode,
      addAmount: comboSet.couponData?.addAmount || 0,
      foodDiscount: comboOrderItem.foodDiscount,
      foodId: comboOrderItem.foodId,
      categoryIds: comboOrderItem.categoryIds,
      foodImageCover: comboOrderItem.foodImageCover,
      foodName: comboOrderItem.foodName,
      option: comboOrderItem.option,
      unit: comboOrderItem.unit,
      optionId: comboOrderItem.option._id,
      optionName: comboOrderItem.option.name,
      isSimple: comboOrderItem.isSimple,
      quantity: comboOrderItem.quantity,
      taxInclusive: comboOrderItem.taxInclusive,
      taxItems: comboOrderItem.taxItems,
      orderItemId: comboOrderItem._id,
      salePrice: comboOrderItem.salePrice,
      orderItemSpecifications: comboOrderItem.orderItemSpecifications
    }

    const comboIndex =
      comboSet.groupNumber - 1

    const previousComboItems =
      combos[comboIndex]?.items || []

    const items =
      [...previousComboItems, newItem]

    combos[comboIndex] = {
      items,
      isBuyxFreeX: comboSet.isBuyxFreeX,
      name: comboSet.name,
      code: comboSet.code,
      groupNumber: comboSet.groupNumber,
      comboSetSalePrice: comboSet.comboSetSalePrice
    }
  })

  combos.forEach((combo, comboIndex) => {
    const totalAddedAmount =
      combo.items.reduce((t, comboItem) =>
        t += comboItem.addAmount
        , 0
      )

    const comboSetSalePrice =
      combo.comboSetSalePrice +
      totalAddedAmount

    const totalItemsSalePrice =
      combo.items.reduce((t, comboItem) =>
        t += comboItem.salePrice * comboItem.quantity
        , 0
      )

    const comboDiscount =
      totalItemsSalePrice - comboSetSalePrice

    combos[comboIndex] = {
      ...combo,
      comboDiscount,
      comboSetSalePrice
    }
  })

  return combos
}

export default convertOrderCombosToCartCombos